import styled from 'styled-components';
import media from "styled-query";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Content = styled.div`
  width: 1120px;
  display: flex;
  justify-content: space-between;
  margin: 0;
  align-items: center;

  /* .title-responsive {
    margin: 1rem 0 1.5rem 0;
    font-size: 2.5rem;
    font-weight: regular;
    display: none;

    span {
      font-size: 2.5rem;
      font-weight: bold;
      color: var(--primary);
      ${media.lessThan("1023px")`
        font-size: 2rem;
      `}
    }
  } */

  .title-normal {
    margin: 1rem 0 1.5rem 0;
    font-size: 2.5rem;
    font-weight: regular;

    span {
      font-size: 2.5rem;
      font-weight: bold;
      color: var(--primary);
      ${media.lessThan("1023px")`
        font-size: 2rem;
      `}
    }
  }

  ${media.lessThan("1200px")`
    margin: 24px;
  `}

  ${media.lessThan("1023px")`
    margin: 24px;
    flex-direction: column;
    text-align: center;
    flex-direction: column;

    /* .title-responsive {
      display: block;
    }
    .title-normal {
      display: none;
    } */
    
  `}
`;

export const Text = styled.div`
  justify-content: space-around;
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex: 2;

  p {
    margin: 1rem 0;
    font-size: 1.2rem;
    font-weight: bold;
  }

  ${media.lessThan("1200px")`
    margin: 24px;
  `}

  ${media.lessThan("1023px")`
    margin: 24px;
    flex-direction: column;
    text-align: center;
    justify-content: center;
  `}
`;

export const Images = styled.div`
  flex: 1;
  max-width: 400px;

  ${media.lessThan("1023px")`
    height: 100px;    
  `}
`;